/** The grid's white hover cards. */

import React from 'react';
import { Tooltip, TooltipContent, TooltipTrigger } from '@roger/ui-components';

/** A white hover card over whatever it wraps. */
export const Tip: React.FC<{
  tip: React.ReactNode;
  children: React.ReactElement;
}> = ({ tip, children }) => (
  <Tooltip>
    <TooltipTrigger asChild>{children}</TooltipTrigger>
    <TooltipContent
      side='top'
      collisionPadding={12}
      className='pointer-events-none max-w-xs text-xs'
    >
      {tip}
    </TooltipContent>
  </Tooltip>
);

/** Each clinic's value, for a field where the clinics disagree. */
export const DiffersTip = <T,>({
  byClinic,
  show,
}: {
  byClinic: { clinic: string; value: T }[];
  show: (value: T) => string;
}) => (
  <div className='space-y-1'>
    <p className='font-medium'>Differs per clinic</p>
    <ul className='space-y-0.5'>
      {byClinic.map(c => (
        <li key={c.clinic} className='flex justify-between gap-4'>
          <span className='truncate text-muted-foreground'>{c.clinic}</span>
          <span className='shrink-0 font-medium'>{show(c.value)}</span>
        </li>
      ))}
    </ul>
  </div>
);
